module.exports = __webpack_public_path__ + "media/images/teaching-bg6A-6e37bec484de3fa7d36e438abdd81d0c.jpeg";